module.exports = __webpack_public_path__ + "img/home5.bd737394.png";